@if (attachments?.length) {
<div class="grid gap-3 py-2" [ngStyle]="{ 'grid-template-columns': 'repeat(' + columns + ', minmax(0, 1fr))' }">
    @for (attachment of attachments; track attachment.id) {
    <div class="relative group border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
        <!-- Image thumbnail -->
        @if (attachment.mimeType?.startsWith('image/')) {
        <a [href]="'Documents/' + attachment.rawData_Path" target="_blank" [download]="attachment.fileName">
            <img
                [src]="'Documents/' + (attachment.thumbnail_Path || attachment.rawData_Path)"
                [alt]="attachment.fileName"
                class="w-full h-24 object-cover" />
        </a>
        } @else {
        <!-- Non-image file icon -->
        <a [href]="'Documents/' + attachment.rawData_Path" target="_blank" [download]="attachment.fileName"
            class="flex flex-col items-center justify-center h-24 bg-gray-50">
            @if (attachment.mimeType === 'application/pdf') {
            <i class="fas fa-file-pdf text-red-500 text-3xl"></i>
            } @else if (attachment.mimeType?.includes('word') || attachment.mimeType?.includes('document')) {
            <i class="fas fa-file-word text-blue-500 text-3xl"></i>
            } @else if (attachment.mimeType?.includes('excel') || attachment.mimeType?.includes('spreadsheet')) {
            <i class="fas fa-file-excel text-green-500 text-3xl"></i>
            } @else {
            <i class="fas fa-file text-gray-400 text-3xl"></i>
            }
        </a>
        }
        <!-- File name + download -->
        <div class="px-2 py-1 bg-white text-xs text-gray-600 truncate flex items-center justify-between">
            <span class="truncate" [title]="attachment.fileName">{{ attachment.fileName }}</span>
            <a [href]="'Documents/' + attachment.rawData_Path" target="_blank" [download]="attachment.fileName"
                class="text-teal-500 hover:text-teal-700 ml-1 flex-shrink-0">
                <i class="fas fa-download"></i>
            </a>
        </div>
    </div>
    }
</div>
} @else {
<p class="text-xs text-gray-400 italic px-2">
    {{ 'vues.truckerActivity.detail.noDocuments' | translate }}
</p>
}